import { createAsyncThunk } from '@reduxjs/toolkit';
import { WidgetSession } from '@wix/wix-chatbot-common/browser';
import { createPath } from 'react-router-dom';

import { WidgetRuntimeData } from '../../../types/appState';
import { appRoutes } from '../../routes';
import { getRouterBaseName, trimBaseName } from '../../routes/utils';
import { widgetSDK } from '../../sdk/widgetSDK';
import { fedopsLogger, renderModel } from '../../util/renderModel';
import { updateHelpWidgetSession } from '../api/updateHelpWidgetSession';
import { HttpClientFactory } from '../httpClient';
import { TRootState } from '../reducers';
import { selectWidgetSessionState } from '../selectors/widgetSession';

const { clientTopology } = renderModel.get();

const getFirstUrl = () => {
  const routerBaseName = getRouterBaseName(window.location.pathname);
  return trimBaseName(routerBaseName, createPath(window.location)) || appRoutes.home();
};

const updateFirstNavigationIfNeeded = async (tabId: string, widgetSession?: WidgetSession) => {
  if (widgetSession && widgetSession.navigationHistory && !widgetSession.navigationHistory.length) {
    await updateHelpWidgetSession({
      id: tabId,
      addedUrl: getFirstUrl(),
    });
  }
};

export const getWidgetRuntimeData = createAsyncThunk<
  WidgetRuntimeData,
  HttpClientFactory,
  { state: TRootState }
>('getWidgetRuntimeData', async (httpClient: HttpClientFactory, { getState }) => {
  if (renderModel.provideRuntimeDataFromSDK()) {
    const runtimeData = await widgetSDK.getRuntimeData();
    const { sessionTabId } = selectWidgetSessionState(getState());
    await updateFirstNavigationIfNeeded(sessionTabId, runtimeData.widgetSession);
    return runtimeData;
  }
  fedopsLogger.interactionStarted('fetching-widget-runtime-data');
  const { data } = await httpClient.getInstance().post(clientTopology.widgetRuntimeUrl);
  fedopsLogger.interactionStarted('fetching-widget-runtime-data');
  return data;
});
